module.exports = require("@agm/core/services/managers/info-window-manager");